var map = {
	"./RegStep1.vue": [
		"l/fw",
		7
	],
	"./RegStep2.vue": [
		"bADA",
		3
	],
	"./RegStep3.vue": [
		"G1M5",
		8
	],
	"./RegStepCounter.vue": [
		"tkF5"
	],
	"./RegStepObsolete.vue": [
		"WmOl",
		10
	],
	"./Registration.vue": [
		"vUT9"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "nb/k";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/components/account/Registration lazy ^\.\/.*\.vue$
// module id = nb/k
// module chunks = 12